import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-hyperCDP",
  "use": "app-icon-hyperCDP-usage",
  "viewBox": "0 0 18 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 15\" id=\"app-icon-hyperCDP\"><path d=\"M12 15H0V2h3.38l1-2h7.24l1 2H16v4h-2V4h-2.62l-1-2H5.62l-1 2H2v9h10v2zm-4-3a4 4 0 110-8 4 4 0 010 8zm0-6a2 2 0 100 4 2 2 0 000-4zm7.5 0l-.75 3.71h3.13L13.38 15l.75-3.71H11L15.5 6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol